import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, Illustration } from '@node-space/ui-components'

interface WalletHasFundsDialogProps {
  walletName: string
  onClose: () => void
  onMoveFunds: () => void
}

export const WalletHasFundsDialog = ({
  walletName,
  onClose,
  onMoveFunds,
}: WalletHasFundsDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open
      onClose={onClose}
      title={t('wallets.actions.walletHasFundsTitle', { walletName })}
      Illustration={<Illustration name="Warning" />}
      ActionButtons={[
        <Button key="move" onClick={onMoveFunds}>
          {t('customers.move')}
        </Button>,
        <Button key="cancel" onClick={onClose} variant="secondary">
          {t('cancel')}
        </Button>,
      ]}
    >
      <p className="text-foreground-prominent text-body-regular text-center">
        {t('wallets.actions.walletHasFundsDescriptionMove')}
      </p>
    </Dialog>
  )
}
